// extracted by mini-css-extract-plugin
export default {"wrap":"StarRate_wrap__5AR3-","star_icon":"StarRate_star_icon__P5AM2"};